import { Component, OnInit } from "@angular/core";
import { TitleService } from "@app/services/title.service";

@Component({
    selector: "app-homepage-four",
    templateUrl: "./homepage-four.component.html",
    styleUrls: ["./homepage-four.component.scss"],
})
export class HomepageFourComponent implements OnInit {
    constructor(private titleService: TitleService) {}

    ngOnInit(): void {
        this.titleService.setTitle("Home");
    }
}
